import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  uploadValidation: ['imgBase64'],
  uploadValidationRequest: null,
  uploadValidationSuccess: ['data'],
  uploadValidationFailure: ['error'],
  uploadValidationClear: null
});

export { Creators, Types };
